var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImageFill = function SvgImageFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm2-4h10q.3 0 .45-.275a.44.44 0 0 0-.05-.525l-2.75-3.675a.48.48 0 0 0-.4-.2q-.25 0-.4.2L11.25 16 9.4 13.525a.48.48 0 0 0-.4-.2q-.25 0-.4.2l-2 2.675a.44.44 0 0 0-.05.525Q6.7 17 7 17"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImageFill);
export { ForwardRef as ReactComponent };